import { formatInVenueZone } from 'utils/shared/time/formatInVenueZone';

/**
 * "Wednesdays" when every session of a program falls on the same weekday in the
 * venue's zone, otherwise null. One session is not a cadence.
 */
export const formatSessionCadence = (
  sessions: { startsAt: string }[],
  timezone?: string | null,
): string | null => {
  if (sessions.length < 2) return null;
  const weekdays = new Set(sessions.map((s) => formatInVenueZone(s.startsAt, 'EEEE', timezone)));
  if (weekdays.size !== 1) return null;
  return `${[...weekdays][0]}s`;
};
